module.exports = __webpack_public_path__ + "media/soar_academics.57d3a194.mp4";